import {defineStore} from 'pinia';
import axios from "../plugins/axios";

// pinia store je docasny komponent, sluzi len na otestovanie ci funguje pinia
// pri zapracovani do projektu treba vytvorit novy store a vymazat tento

export const usePiniaStore = defineStore('pinia', {
  state: () => ({
    count: 0,
  }),

  actions: {
    increment(): void {
      this.count++;
    },

    async fetchCustomerQrConfiguration(payload: any): Promise<any> {

      const response = await axios.get(`/api/customer/${payload}`)
      return response.data

    },

    async fetchLastOrder(payload: any): Promise<any> {

      const response = await axios.get(`/api/food-ordering/offer-reservation/${payload}`)
      return response.data

    },

    async createNewRating(payload: any): Promise<any> {
      const response = await axios.post(`/api/rating/offer-reservation-rating`,{
        offerReservations: payload.offerReservations,
        value: payload.value,
        note: payload.note
      })
      return response.data
    },

    async fetchOfferRating(payload: any): Promise<any> {
      const response = await axios.get(`/api/rating/offer-reservation-rating?boarder.id=${payload.boarderId}&offerReservations.id=${payload.id}`)
      return response.data
    },

    async updateSelectedRating(payload: any): Promise<any> {
      const response = await axios.put(`/api/rating/offer-reservation-rating/${payload.id}`,{
        boarder: payload.boarderId,
        value: payload.value,
        note: payload.note,
        offerReservations: payload.offerReservations
      })
      return response.data
    },
  },
});
